export interface StackColorFamily {
  readonly id: string;
  readonly label: string;
  readonly swatches: readonly [string, string, string, string, string];
}

export const STACK_COLOR_FAMILIES: ReadonlyArray<StackColorFamily> = [
  { id: 'red',    label: 'Red',    swatches: ['#b91c1c', '#ef4444', '#f87171', '#fca5a5', '#fecaca'] },
  { id: 'orange', label: 'Orange', swatches: ['#c2410c', '#f97316', '#fb923c', '#fdba74', '#fed7aa'] },
  { id: 'amber',  label: 'Amber',  swatches: ['#b45309', '#f59e0b', '#fbbf24', '#fcd34d', '#fef3c7'] },
  { id: 'green',  label: 'Green',  swatches: ['#15803d', '#22c55e', '#4ade80', '#86efac', '#dcfce7'] },
  { id: 'teal',   label: 'Teal',   swatches: ['#0f766e', '#14b8a6', '#2dd4bf', '#5eead4', '#ccfbf1'] },
  { id: 'brand',  label: 'Brand',  swatches: ['#0077a3', '#00a0dc', '#33b8e8', '#80d5f2', '#c2ecfb'] },
  { id: 'blue',   label: 'Blue',   swatches: ['#1d4ed8', '#3b82f6', '#60a5fa', '#93c5fd', '#dbeafe'] },
  { id: 'indigo', label: 'Indigo', swatches: ['#4338ca', '#6366f1', '#818cf8', '#a5b4fc', '#e0e7ff'] },
  { id: 'purple', label: 'Purple', swatches: ['#7e22ce', '#a855f7', '#c084fc', '#d8b4fe', '#f3e8ff'] },
  { id: 'pink',   label: 'Pink',   swatches: ['#be185d', '#ec4899', '#f472b6', '#f9a8d4', '#fce7f3'] },
  { id: 'slate',  label: 'Slate',  swatches: ['#334155', '#64748b', '#94a3b8', '#cbd5e1', '#e2e8f0'] },
];
